<template>
  <div class="modal-header">
    <div class="container px-0">
      <div class="modal-title">
        Informazioni
      </div>
      <button type="button" class="close" data-dismiss="modal">
        <div class="close-span">
          CHIUDI
          <div class="icon icon-cross" aria-hidden="true"/>
        </div>
      </button>
    </div>
  </div>
  <div class="modal-body container confirmation-alert-modal">
    <div class="row">
      <div class="col-xl-6 col-lg-8 col-md-9 col-12 h-100 mx-auto information-box modal-centered">
        <div class="extension-title">
          <template v-if="this.status=='none'">
            Vuoi ricevere un avviso via mail quando questo viaggio sarà confermato?
          </template>
          <template v-else-if="this.status=='true'">
            <div class="icon icon-success"></div>
            Complimenti,<br>l'operazione è avvenuta con successo.
          </template>
          <template v-else-if="this.status=='false'">
            <div class="icon icon-cancel"></div>
            Oooops,<br />qualcosa è andato storto.
          </template>
        </div>

        <p class="modal-description">
          <template v-if="this.status=='none'">
            Stiamo raccogliendo le adesioni per questo tour. Riceverai un<br/>avviso via mail non appena questa partenza sarà confermata!
          </template>
          <template v-else-if="this.status=='true'">
            Abbiamo correttamente ricevuto tutti i tuoi dati e, se necessario, ti contatteremo nel più breve tempo possibile.
          </template>
          <template v-else-if="this.status=='false'">
            Scusandoci per il disagio,<br/>ti informiamo che l'operazione si è interrotta e non è stato possibile procedere.<br/>
            Puoi fare un altro tentativo e, se il problema dovesse persistere,<br/>ti invitiamo a contattare il nostro servizio clienti
          </template>
        </p>

        <form class="mail-box" @submit.prevent="submitConfirmation()" novalidate v-if="this.status=='none'">
          <div class="mail-title">Lascia la tua email<span class="required">*</span></div>
          <div class="mail-input-container">
            <div class="form-group required mail-input">
              <input type="email" v-model="form.email" aria-required="true" aria-describedby="form-email-error" class="form-control required email" v-bind:class="this.invalidInput.indexOf('email')!=-1?'is-invalid':''"/>
              <div class="invalid-feedback" id="form-email-error">Inserire un indirizzo email valido</div>
            </div>
            <button type="submit" class="btn btn-primary background-gold3 text-uppercase email-button">Avvisami</button>
          </div>

          <div class="checkbox-container">
            <div class="custom-control custom-switch">
              <input type="checkbox" v-model="form.checkbox" class="custom-control-input" v-bind:class="this.invalidInput.indexOf('checkbox')!=-1?'is-invalid':''" id="informativa">
              <label class="custom-control-label" for="informativa">Letta l’informativa privacy autorizzo l’iscrizione alla newsletter Boscolo</label>
            </div>
          </div>
        </form>
        <button type="button" class="btn btn-primary background-gold3 text-uppercase email-button" data-dismiss="modal" v-else-if="this.status=='true'">Ok, grazie</button>
        <button type="button" class="btn btn-primary background-gold3 text-uppercase email-button" v-on:click="this.status='none'" v-else-if="this.status=='false'">Riprova</button>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapState} from "vuex";

export default {
  name: "confirmationAlertModal",
  data() {
    return {
      form: {
        email: '',
        checkbox: ''
      },
      invalidInput: [],
      status: 'none'
    }
  },
  computed: {
    ...mapState([
      'modal',
      'modalstatus'
    ]),
    dataUser() {
      return JSON.parse(JSON.stringify(this.modal.data));
    }
  },
  watch: {
    // whenever question changes, this function will run
    modalstatus(newModalstatus, oldModalstatus) {
      if(newModalstatus !== 'none') {
        this.status = newModalstatus;
        this.setModalStatus('none');
      }
    }
  },
  methods: {
    ...mapActions([
      'getResponseAPI',
      'setModalStatus'
    ]),
    submitConfirmation() {
      this.invalidInput = [];      
      var regmail = /^(?!.*[(){}\[\]/\\*€$£¥+'"#<>°&àèìòùáéíóúäëïöüãõâêîôûçøåßñÁÉÍÓÚÄËÏÖÜÃÕÂÊÎÔÛÇØÅÑ\s])[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;                     

      if(!regmail.test(this.form.email))
        this.invalidInput.push('email');
      if(!this.form.checkbox)
        this.invalidInput.push('checkbox');
      if(regmail.test(this.form.email) && this.form.checkbox){
        this.dataUser.specific_input.email = this.form.email;
        this.getResponseAPI({url:'notify', method:'POST' , param: { datauser: JSON.stringify(this.dataUser)}});
      }
    }
  }
}
</script>

<style scoped>

</style>